
document.addEventListener('DOMContentLoaded', function() {
    const slideshows = document.querySelectorAll('.custom_slideshow');
    
    slideshows.forEach(slideshow => {
        slideshow.addEventListener('click', function(e) {
            // Don't scroll if clicking directly on interactive elements
            if (!e.target.closest('button, a, input, select, textarea, [onclick]')) {
                const targetSection = document.querySelector('.shopify-section.section');
                
                if (targetSection) {
                    // Calculate position with some offset (100px in this case)
                    const targetPosition = targetSection.getBoundingClientRect().top + window.pageYOffset - 100;
                    
                    window.scrollTo({
                        top: targetPosition,
                        behavior: 'smooth'
                    });
                }
            }
        });
    });
});
